module.exports = __webpack_public_path__ + "static/media/hoodie-woman-back-min.a218ef69.png";